(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delivery-estimator"] && !Shopify.designMode) return;
  try {
    class DeliveryEstimator extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[name="delivery_zip"]');
      this.status = this.querySelector('.delivery-estimator__status');
      this.button = this.querySelector('button[type="submit"]');
      this.endpoint = this.dataset.endpoint;
      this.productForm = document.getElementById(this.dataset.productFormId);
      this.variants = this.readVariants();
      this.holidays = this.readHolidays();
      this.autoHolidays = this.automaticUpsHolidays();
      this.form.addEventListener('submit', (event) => this.handleSubmit(event));
    }

    readVariants() {
      const data = this.querySelector('[data-delivery-estimator-variants]');
      try {
        return JSON.parse(data.textContent);
      } catch (error) {
        return [];
      }
    }

    readHolidays() {
      return new Set(
        (this.dataset.holidays || '')
          .split(',')
          .map((value) => value.trim())
          .filter((value) => /^\d{4}-\d{2}-\d{2}$/.test(value))
      );
    }

    dateKey(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

    fixedDate(year, month, day) {
      return new Date(year, month, day, 12);
    }

    nthWeekdayDate(year, month, weekday, occurrence) {
      const date = this.fixedDate(year, month, 1);
      const offset = (weekday - date.getDay() + 7) % 7;
      date.setDate(1 + offset + ((occurrence - 1) * 7));
      return date;
    }

    lastWeekdayDate(year, month, weekday) {
      const date = this.fixedDate(year, month + 1, 0);
      const offset = (date.getDay() - weekday + 7) % 7;
      date.setDate(date.getDate() - offset);
      return date;
    }

    automaticUpsHolidays() {
      const years = [new Date().getFullYear() - 1, new Date().getFullYear(), new Date().getFullYear() + 1];
      const dates = new Set();

      years.forEach((year) => {
        [
          this.fixedDate(year, 0, 1),
          this.nthWeekdayDate(year, 0, 1, 3),
          this.lastWeekdayDate(year, 4, 1),
          this.fixedDate(year, 6, 4),
          this.nthWeekdayDate(year, 8, 1, 1),
          this.nthWeekdayDate(year, 10, 4, 4),
          this.fixedDate(year, 11, 25)
        ].forEach((date) => dates.add(this.dateKey(date)));
      });

      return dates;
    }

    isBusinessDateKey(dateKey, weekday) {
      return weekday !== 0 && weekday !== 6 && !this.holidays.has(dateKey) && !this.autoHolidays.has(dateKey);
    }

    selectedVariant() {
      const selectedId = this.productForm && this.productForm.querySelector('[name="id"]');
      return this.variants.find((variant) => String(variant.id) === String(selectedId && selectedId.value)) || this.variants[0];
    }

    easternNow() {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(new Date());
      const value = (type) => parts.find((part) => part.type === type).value;
      const year = Number(value('year'));
      const month = Number(value('month'));
      const day = Number(value('day'));
      return {
        dateKey: `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`,
        weekday: new Date(Date.UTC(year, month - 1, day)).getUTCDay(),
        hour: Number(value('hour'))
      };
    }

    processingBusinessDays() {
      const now = this.easternNow();
      if (!this.isBusinessDateKey(now.dateKey, now.weekday)) return 1;
      return now.hour >= 12 ? 1 : 0;
    }

    addBusinessDays(date, days) {
      const adjusted = new Date(date);
      let remaining = days;
      while (remaining > 0) {
        adjusted.setDate(adjusted.getDate() + 1);
        const weekday = adjusted.getDay();
        if (this.isBusinessDateKey(this.dateKey(adjusted), weekday)) remaining -= 1;
      }
      return adjusted;
    }

    setStatus(message, state) {
      this.status.textContent = message;
      this.status.dataset.state = state || '';
    }

    async handleSubmit(event) {
      event.preventDefault();
      const destinationZip = this.input.value.trim();
      if (!/^\d{5}$/.test(destinationZip)) {
        this.setStatus(this.dataset.invalidMessage, 'error');
        this.input.focus();
        return;
      }
      if (!this.endpoint) {
        this.setStatus(this.dataset.unconfiguredMessage, 'error');
        return;
      }
      const variant = this.selectedVariant();
      if (!variant) {
        this.setStatus(this.dataset.variantMessage, 'error');
        return;
      }
      this.button.disabled = true;
      this.setStatus(this.dataset.checkingMessage);
      try {
        const response = await fetch(this.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            destinationZip,
            sourceZip: variant.originZip,
            productId: this.dataset.productId,
            variantId: variant.id,
            sku: variant.sku
          })
        });
        const result = await response.json();
        if (!response.ok || !result.estimatedDeliveryDate) throw new Error(result.message || 'Estimate unavailable');
        const processingDays = this.processingBusinessDays();
        const date = this.addBusinessDays(new Date(`${result.estimatedDeliveryDate}T12:00:00`), processingDays);
        const formattedDate = new Intl.DateTimeFormat(undefined, { weekday: 'long', month: 'long', day: 'numeric' }).format(date);
        const message = this.dataset.estimateTemplate
          .replace('[service]', result.service || 'UPS')
          .replace('[date]', formattedDate);
        const processingNote = processingDays ? ' Includes next-business-day processing.' : '';
        this.setStatus(`${message}${processingNote}`, 'success');
      } catch (error) {
        this.setStatus(this.dataset.errorMessage, 'error');
      } finally {
        this.button.disabled = false;
      }
    }
  }

  if (!customElements.get('delivery-estimator')) customElements.define('delivery-estimator', DeliveryEstimator);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["express-shipping-quote"] && !Shopify.designMode) return;
  try {
    class ExpressShippingQuote extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      if (this.dataset.context !== 'product') return;

      const variantData = this.querySelector('[data-quote-variants]');
      try {
        this.variants = JSON.parse(variantData.textContent);
      } catch (error) {
        this.variants = [];
      }
      this.productForm = document.querySelector('form[action*="/cart/add"]');
      if (!this.productForm) return;

      this.refreshLinks();
      this.productForm.addEventListener('change', () => window.setTimeout(() => this.refreshLinks(), 0));
    }

    refreshLinks() {
      const idInput = this.productForm.querySelector('[name="id"]');
      const selectedVariant = this.variants.find((variant) => String(variant.id) === String(idInput && idInput.value));
      const sku = selectedVariant && selectedVariant.sku ? ` — SKU: ${selectedVariant.sku}` : '';
      const message = `Hi Prima Supply, I would like an express UPS shipping quote for ${this.dataset.productTitle}${sku}. My delivery ZIP code is: `;
      this.updateLinks(message);
    }

    updateLinks(message) {
      const encodedMessage = encodeURIComponent(message);
      const phone = this.dataset.phone;
      const email = this.dataset.email;
      this.querySelector('[data-quote-link="whatsapp"]').href = `https://wa.me/${phone}?text=${encodedMessage}`;
      this.querySelector('[data-quote-link="email"]').href = `mailto:${email}?subject=${encodeURIComponent('Express UPS shipping quote')}&body=${encodedMessage}`;
      this.querySelector('[data-quote-link="text"]').href = `sms:+${phone}?&body=${encodedMessage}`;
    }
  }

  if (!customElements.get('express-shipping-quote')) customElements.define('express-shipping-quote', ExpressShippingQuote);
  } catch(e) { console.error(e); }
})();

})();
